// Subscription Tier Types
export interface ISubscriptionTier {
  id: string;
  name: string;
  displayName: string;
  description?: string;
  featureSummary?: string;
  inheritsFrom?: string;
  maxUsers: number;
  maxAiTokens: number;
  maxScheduledJobs: number;
  maxRowsAllowed: number;
  maxPagesAllowed: number;
  maxValidationRulesAllowed: number;
  maxApiConnectorsAllowed: number;
  maxAutomationWorkflowsAllowed: number;
  maxEmailIntegrationsAllowed: number;
  maxNotificationRecipientsAllowed?: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  allFeatures: string[];
  productEdition: SubscriptionProductEdition;
  paddleProductId?: string;
  pricing?: IPricingInfo[];
}

export interface ICreateSubscriptionTierRequest {
  name: string;
  displayName: string;
  description?: string;
  inheritsFrom?: string;
  maxUsers: number;
  maxAiTokens: number;
  maxScheduledJobs: number;
  maxRowsAllowed: number;
  maxPagesAllowed: number;
  featureGroupIds?: string[];
  pricing?: IPricingConfiguration[];
  isActive?: boolean;
  productType?: SubscriptionProductEdition;
}

export interface IUpdateSubscriptionTierRequest {
  id: string;
  name?: string;
  displayName?: string;
  description?: string;
  inheritsFrom?: string;
  maxUsers?: number;
  maxAiTokens?: number;
  maxScheduledJobs?: number;
  maxRowsAllowed?: number;
  maxPagesAllowed?: number;
  featureGroupIds?: string[];
  pricing?: IPricingConfiguration[];
  isActive?: boolean;
  productType?: SubscriptionProductEdition;
}

export interface IProductEdition {
  name: SubscriptionProductEdition;
  description: string;
}

// State Types
export type ISubscriptionTierState = {
  subscriptionTierList: ISubscriptionTier[];
  currentSubscriptionTier: ISubscriptionTier;
  isModalOpen: boolean;
  isLoading: boolean;
  productEditions: IProductEdition[];
};

// Form Field Types
export type SubscriptionTierFormFieldType = {
  name?: string;
  displayName?: string;
  description?: string;
  inheritsFrom?: string;
  maxUsers?: number;
  maxAiTokens?: number;
  maxScheduledJobs?: number;
  maxRowsProcessed?: number;
  productEdition?: SubscriptionProductEdition;
};

export interface CardFeatureList {
  key: string;
  label: string;
  state: "included" | "limited" | "not_included";
  value?: number | string;
  order?: number;
  description?: string; 
  descriptionFormat?: "paragraph" | "list"; 
  descriptionItems?: string[]; 
}

export interface IPricingConfiguration {
  billingInterval: "monthly" | "annually";
  priceInCents: number;
  currency?: string;
  description?: string;
  paddlePriceId?: string;
}

export interface IPricingInfo {
  billingInterval: string;
  priceInCents: number;
  currency: string;
  description?: string;
  paddlePriceId?: string;
  paddleProductId?: string;
  isActive: boolean;
  createdAt: string;
}

export enum SubscriptionProductEdition {
  CenterpriseReportMiner = "CenterpriseReportMiner",
  CenterpriseEdi = "CenterpriseEdi",
  CenterpriseAnalytics = "CenterpriseAnalytics",
  CenterpriseDataIntegrator = "CenterpriseDataIntegrator",
  CenterpriseDataWarehousing = "CenterpriseDataWarehousing",
  CenterpriseDataServices = "CenterpriseDataServices",
  ReadOnly = "ReadOnly",
  ReportMinerPersonal = "ReportMinerPersonal",
  CenterpriseStudentEdition = "CenterpriseStudentEdition",
  CenterpriseTrialEdition = "CenterpriseTrialEdition",
  CenterpriseBaseEdition = "CenterpriseBaseEdition",
  DPBDataPrep = "DPBDataPrep",
  DataPrepPersonal = "DataPrepPersonal",
  Docspire = "Docspire",
}
